<main id="main">
  <header class="process-header">
    <h2>Potwierdzenie zamówienia na</h2>
    <h1>{{productName}}</h1>

  </header>
  <section class="section process-content">
    <article class="section__left">

      <div class="order-info">
        <div>Zamówienie wykonuje</div>
        <div>Maio Software House sp. z o.o.</div>

        <div>Zamawiasz</div>
        <div>{{productName}}</div>

        <div >Osoba zmarła</div>
        <div>{{order.deceased.name}} {{order.deceased.lastName}}</div>

        <div >Cena do zapłacenia</div>
        <div>{{productPrice? (productPrice | currency:'PLN':'symbol':'1.0-0'): "-"}}</div>

        <div >Dostępne sposoby płatności</div>
        <div>karta płatnicza, przelew, BLIK</div>

        <div >Termin płatności</div>
        <div>NATYCHMIASTOWY</div>

        <div >Termin wykonania usługi</div>
        <div><span>DO 3 DNI ROBOCZYCH<br><small><i>ZAZWYCZAJ DO 15 MINUT</i></small></span></div>

        <div>Dostawa usługi</div>
        <div>online / e-mail</div>

        <div >Zawarcie umowy</div>
        <div>w momencie dokonania płatności</div>

      </div>
      <img class="logo" src="assets/images/logo.svg"/>
    </article>

    <article class="section__right">
        <div class="section__right--one-column margin-top-s align-grid-self-top"><p class="process-content__highlight no-margins">Zweryfikuj poniższe informacje i opłać zamówienie.</p></div>
        <div>
            <h3>Osoba zmarła</h3>
          <hr class="underline"/>
          <p> <strong>{{order.deceased.name}} {{order.deceased.lastName}}</strong></p>
            <p><strong>PESEL: </strong>{{order.deceased.peselNumber}}</p>
            <p><strong>NIP: </strong>{{order.deceased.taxId || 'brak'}}</p>
            <p><strong>Data śmierci: </strong>{{order.deceased.dateOfDeath }}</p>
        </div>
        <div>
          <h3>Zamawiający</h3>
          <hr class="underline"/>
          <p><strong>{{order.client.name}} {{order.client.lastName}}</strong></p>
          <p>{{order.payer.street}}</p>
          <p>{{order.payer.postalCode}} {{order.payer.city}}</p>
          <p>{{order.client.email}}</p>
        </div>
      <div class="section__right--one-column align-grid-self-bottom">
            <button class="cta cta-white product__button cta--100-w" (click)="navigate(orderEditUrl)">
              Popraw dane
            </button>
       </div>
<!--      <div>&nbsp;</div>-->
      <div class="section__right--one-column align-grid-self-bottom">
              <button class="cta primary product__button cta--100-w pay-button-with-logo" (click)="onAcceptAndPay()">
                Potwierdzam i płacę <img src="assets/payments/payu-logo.svg" alt="payu logo"/>
              </button>
      </div>
<!--      <div class="payments">-->

<!--        <img src="assets/payments/payu-logo.svg" alt="payu logo"/>-->

<!--      </div>-->
      <div class="section__right--one-column align-grid-self-bottom">
        <p class="no-margins"><small>Jeśli potwierdzisz to zamówienie i je opłacisz, rozpoczniemy świadczenie dla Ciebie usługi przed upływem 14 dniowego terminu odstąpienia od umowy. Oznacza to, że nie będzie możliwe odstąpienie od umowy. Potwierdzając zamówienie akceptujesz warunki <a href="/assets/downloads/2025.05.09_Regulamin_mSpadek.pdf" target="_blank" rel="noopener noreferrer">Regulaminu</a>.</small></p>
      </div>
              </article>
            </section>

          </main>
          <!--<main id="main">-->

<!--    <div class="inner">-->
<!--        <div *ngIf="!order">-->
<!--          <div class="process-content">-->
<!--            <p class="process-content__highlight">Zamówienie nie znalezione.</p>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div *ngIf="order">-->

<!--          <div class="process-header">-->
<!--            <h2>Podsumowanie zamówienia na</h2>-->
<!--            <h1 *ngIf="productType ==='PRIMARY'">Podstawowy raport spadkowy</h1>-->
<!--            <h1 *ngIf="productType==='EXTENDED'">Rozszerzony raport spadkowy</h1>-->
<!--          </div>-->

<!--          <div class="process-content">-->
<!--            <p class="process-content__highlight">Zweryfikuj poniższe informacje i opłać zamówienie.</p>-->

<!--            <div class="row order-preview-details">-->
<!--                <section>-->
<!--                  <h3>Osoba zmarła</h3>-->
<!--                  <h4 class="space-bellow">{{order.deceased.name}} {{order.deceased.lastName}}</h4>-->
<!--                  <p><strong>PESEL: </strong>{{order.deceased.peselNumber}}</p>-->
<!--                  <p><strong>NIP: </strong>{{order.deceased.taxId || 'brak'}}</p>-->
<!--                  <p><strong>Data śmierci: </strong>{{order.deceased.dateOfDeath }}</p>-->
<!--                </section>-->

<!--                <section>-->
<!--                    <h3>Zamawiający</h3>-->
<!--                    <h4>{{order.client.name}} {{order.client.lastName}}</h4>-->
<!--                    <p>{{order.payer.street}}</p>-->
<!--                    <p>{{order.payer.postalCode}} {{order.payer.city}}</p>-->
<!--                    <p>{{order.client.email}}</p>-->

<!--                </section>-->

<!--&lt;!&ndash;                <section class="col-lg-4">&ndash;&gt;-->
<!--&lt;!&ndash;                    <h3>Płatnik</h3>&ndash;&gt;-->
<!--&lt;!&ndash;                    <p><strong>{{order.payer.name || 'John' }} {{order.payer.lastName || 'Doe'}}</strong></p>&ndash;&gt;-->
<!--&lt;!&ndash;                    <p>{{order.payer.street || 'Testowa 12'}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;                    <p>{{order.payer.postalCode || '00-000'}} {{order.payer.city || 'Warszawa'}}</p>&ndash;&gt;-->
<!--&lt;!&ndash;                </section>&ndash;&gt;-->
<!--            </div>-->

<!--            <div class="row order-preview-details">-->
<!--              <section class="col-4">-->
<!--                  <p>Zamówienie wykonuje</p>-->
<!--                  <p>Zamawiasz</p>-->
<!--                  <p>Osoba zmarła</p>-->
<!--                  <p>Cena do zapłacenia</p>-->
<!--                  <p>Dostępne sposoby płatności</p>-->
<!--                  <p>Termin płatności</p>-->
<!--                  <p>Termin wykonania raportu</p>-->
<!--                  <p>Dostawa raportu</p>-->
<!--                  <p>Zawarcie umowy</p>-->
<!--              </section>-->

<!--              <section class="col-4">-->
<!--                  <p>mSpadek Sp. z o.o.</p>-->
<!--                  <p>{{productType.toUpperCase() === "PRIMARY" ? 'Podstawowy raport spadkowy' : 'Rozszerzony raport spadkowy'}}</p>-->
<!--                  <p>{{order.deceased.name}} {{order.deceased.lastName}}</p>-->
<!--                  <p>{{productType.toUpperCase() === "PRIMARY" ? '1 zł' : '49 zł'}}</p>-->
<!--                  <p>karta płatnicza, przelew, BLIK</p>-->
<!--                  <p>NATYCHMIASTOWY</p>-->
<!--                  <p>NATYCHMIASTOWY / 14 DNI</p>-->
<!--                  <p>online / e-mail</p>-->
<!--                  <p>w momencie dokonania płatności</p>-->
<!--              </section>-->
<!--            </div>-->

<!--            <div>-->
<!--              <section class="col-lg-8">-->
<!--                <p>Jeśli potwierdzisz to Zamówienie, opłacisz je i rozpoczniemy świadczenie dla Ciebie usługi przed upływem terminu odstąpienia od umowy nie będzie możliwe odstąpienie od umowy.-->
<!--                   Potwierdzając zamówienie akceptujesz warunki Regulaminu.-->
<!--                </p>-->
<!--              </section>-->
<!--              <section class="col-lg-4"></section>-->
<!--            </div>-->


<!--            <div class="row action">-->
<!--              <div class="col-lg-12 text-center buttons">-->
<!--                <button class="cta cta-white product__button" (click)="navigate(orderEditUrl)">-->
<!--                  Popraw dane-->
<!--                </button>-->
<!--                <button class="cta primary product__button" (click)="onSubmit()">-->
<!--                  Potwierdzam i płacę-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->

<!--           </div>-->

<!--        </div>-->

<!--    </div>-->
<!--</main>-->
